import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  fullWidth = false
}) => {
  return <motion.a href="https://rinconebook.shop/cart/add?id=48382527340799&quantity=1" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`
        inline-flex items-center justify-center
        bg-brand-cta hover:bg-brand-cta-hover
        text-white font-bold text-lg md:text-xl
        py-4 px-8 rounded-full shadow-lg
        transition-colors duration-300
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-41">
      {children}
    </motion.a>;
};